import { LogoSvg } from "./logo-svg";
import { cn } from "@/lib/cn";

/**
 * Kelime markası. Vektör: her ölçekte net, tek dosya, mürekkep rengi temadan gelir
 * (`currentColor` → açık temada koyu, koyu temada beyaz). PNG sürümler paylaşım/OG için duruyor.
 */
export function Logo({ height = 26, className }: { height?: number; className?: string }) {
  return (
    <span className={cn("inline-flex items-center", className)}>
      <LogoSvg height={height} />
    </span>
  );
}
